import { FC, Fragment } from 'react'
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
import { IBucketResult } from 'models/Bucket';
import IPostQuizPage from 'models/PostQuizPage';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { createAnalyticsInteract } from 'store/player/playerAsync';
// Selectors
import { selectTopBucket, selectPostQuizPageByTopBucket, selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';

const TopBuckets:FC = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const bucket:IBucketResult | null = useAppSelector(selectTopBucket);
  const postQuizPage:IPostQuizPage | undefined = useAppSelector(selectPostQuizPageByTopBucket);
  const result:any = useAppSelector(selectResult);

  const handleClick = () => {
    if ( !postQuizPage ) return;

    dispatch(createAnalyticsInteract({
      result: result.currentUserResult._id,
      name: 'proceedClick'
    }));
  }

  if ( quiz.type !== QuizTypes.Personality ) return null;
  return (
    <Fragment>
      {bucket ? (
        <div className="py-2 px-3 text-center text-primary mb-4">
          {postQuizPage && postQuizPage.callToAction.text ? (
            <span className="block text-base">{postQuizPage.callToAction.text}</span>
          ) : null}
          <span className="block text-2xl font-bold">{bucket.title}</span>
        </div>
      ) : null}
      {postQuizPage ? (
        <Fragment>
          {postQuizPage.callToAction.image ? (
            <a
              className="block rounded mb-4 overflow-hidden border border-white"
              href={postQuizPage.callToAction.url}
              target="_blank"
              rel="noreferrer"
              onClick={handleClick}
            ><img src={postQuizPage.callToAction.image} alt={postQuizPage.callToAction.text} /></a>
          ) : null}
          {postQuizPage.callToAction.url ? (
            <div className="text-center">
              <a
                className="
                  py-2 px-4
                  inline-block rounded-2xl
                  font-semibold text-[#282728]
                  bg-gradient-to-b from-[#fdb22b] to-[#fdc92b] hover:from-[#fdc92b] hover:to-[#fdb22b]
                "
                href={postQuizPage.callToAction.url}
                target="_blank"
                rel="noreferrer"
                onClick={handleClick}
              >{postQuizPage.callToAction.buttonTitle}</a>
            </div>
          ) : null}
        </Fragment>
      ) : null}
    </Fragment>
  )
}

export default TopBuckets;
